import React from 'react';
import { Link } from 'react-router-dom';
import "./footer-link.css";

const FooterLink = (
  {
    link,
    name
  }
) => {
  return (
    <Link to={ link } className="footer__link">
      <span style={{marginRight:'5px'}}>{ name }</span>
      <i className="fas fa-angle-right" />
    </Link>
  )
};


export default FooterLink;


// WEBPACK FOOTER //
// ./src/components/footer-link/footer-link-component.js